import React from 'react';
import PropTypes from 'prop-types';

import { Card } from 'react-bootstrap-5';

import ManagedInput from 'components/form/managed_input';
import UserSelector from './user_selector';

export default function CompanyGridUsers({ companyGrid, users, onChange }) {
  return <React.Fragment>
    <Card>
      <Card.Body>
        <ManagedInput
          checked={companyGrid.enabledForAllUsers}
          name="enabledForAllUsers"
          type="checkbox"
          onChange={onChange}
        >
          Enable for all users
        </ManagedInput>

        <div className="mt-2">
          Unchecking will allow you to grant access to this grid template on a per-user basis.
        </div>
      </Card.Body>
    </Card>

    {!companyGrid.enabledForAllUsers && (
      <UserSelector
        selectedUserIds={companyGrid.enabledUserIds}
        users={users}
        onChange={enabledUserIds => onChange({ enabledUserIds })}
      />
    )}
  </React.Fragment>;
}

CompanyGridUsers.propTypes = {
  companyGrid: PropTypes.shape({
    enabledForAllUsers: PropTypes.bool,
    selectedUserIds: PropTypes.array,
  }).isRequired,
  users: PropTypes.array,
  onChange: PropTypes.func.isRequired,
};
